import { render } from "./day-two.vue?vue&type=template&id=0fd71188"
import script from "./day-two.vue?vue&type=script&lang=js"
export * from "./day-two.vue?vue&type=script&lang=js"

import "./day-two.vue?vue&type=style&index=0&id=0fd71188&lang=scss"
script.render = render

export default script